'use client'

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { applyLeverageEcho } from '@/lib/papertrade/leverage'
import { getAccountSettings, setLeverage } from '@/service/account-settings.api'
import type {
  AccountSettings,
  SetLeverageRequest,
  SetLeverageResponse,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export const accountSettingsKeys = {
  one: (accountId: string) => ['account-settings', accountId] as const,
}

export function useAccountSettings(accountId?: string) {
  return useQuery({
    queryKey: accountSettingsKeys.one(accountId ?? ''),
    queryFn: () => getAccountSettings(accountId!),
    enabled: Boolean(accountId),
    staleTime: 5 * 60 * 1000,
  })
}

export function useSetLeverage() {
  const queryClient = useQueryClient()
  return useMutation<SetLeverageResponse, ErrorResponse, SetLeverageRequest>({
    mutationFn: setLeverage,
    onSuccess: (echo) => {
      queryClient.setQueryData<AccountSettings | undefined>(
        accountSettingsKeys.one(echo.accountId),
        (prev) => applyLeverageEcho(prev, echo)
      )
    },
  })
}
